import merchantGatewayApi from 'apis/merchant-gateway/api';
import { OfferingPlatformScope } from 'modules/shared-menu/types';

import {
  CreateSelectionFromXmenuFilePayload,
  GenerateAiDescriptionResponse,
  GenerateAiProductFamilySuccessResponse,
  GenerateAiProductFamilyErrorResponse,
  Product,
  ProductInformationSettingsV2,
  ProductFamilyAiSuggestionPayload,
  ProductSearchResponse,
} from './types';

export const OFFER_LISTING_SERVICE = '/offer-listing-service';

export const searchCatalogProductsByGtins = async (gtins: string[], scope: OfferingPlatformScope): Promise<Product[]> =>
  merchantGatewayApi
    .post<ProductSearchResponse>(`${OFFER_LISTING_SERVICE}/search-product/by-gtins`, {
      gtins,
      scope,
    })
    .then(response => response.data);

export const searchCatalogProducts = async (query: string, scope: OfferingPlatformScope): Promise<Product[]> =>
  merchantGatewayApi
    .post<ProductSearchResponse>(`${OFFER_LISTING_SERVICE}/search-product/query`, {
      query,
      scope,
    })
    .then(response => response.data);

export const getProductById = async (productId: string): Promise<Product> =>
  merchantGatewayApi.get<Product>(`${OFFER_LISTING_SERVICE}/product/${productId}`).then(response => response.data);

export const getProductByIds = async (productIds: string[]): Promise<Product[]> =>
  merchantGatewayApi
    .post<ProductSearchResponse>(`${OFFER_LISTING_SERVICE}/product`, {
      product_ids: productIds,
    })
    .then(response => response.data);

export const importXmenuJson = (payload: CreateSelectionFromXmenuFilePayload) =>
  merchantGatewayApi.post(`${OFFER_LISTING_SERVICE}/xmenushared/`, payload).then(response => response.data);

export const generateAiDescription = async (prompt: string, language: Language) =>
  merchantGatewayApi
    .post<GenerateAiDescriptionResponse>(`${OFFER_LISTING_SERVICE}/ai/offer/descriptions`, { prompt, language })
    .then(response => response.data);

export const getProductInformationSettings = async () =>
  merchantGatewayApi
    .get<ProductInformationSettingsV2>(`${OFFER_LISTING_SERVICE}/product-information/settings`)
    .then(response => response.data);

export const generateAiProductFamilySuggestion = async ({
  name,
  country_code,
  description,
  category,
  product_line,
  is_retail,
  merchant_id,
  brand_id,
}: ProductFamilyAiSuggestionPayload) =>
  merchantGatewayApi
    .post<GenerateAiProductFamilySuccessResponse | GenerateAiProductFamilyErrorResponse>(
      `${OFFER_LISTING_SERVICE}/ai/product-family/suggestion`,
      {
        country_code,
        name,
        description,
        category,
        product_line,
        is_retail,
        merchant_id,
        brand_id,
      },
    )
    .then(response => response.data);
